import { Analytics } from "@vercel/analytics/react";
import { inject } from "@vercel/analytics";

inject();

export default Analytics;
